import { render, staticRenderFns } from "./BuildingInfo.vue?vue&type=template&id=05fd2f06&scoped=true&"
import script from "./BuildingInfo.vue?vue&type=script&lang=js&"
export * from "./BuildingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuildingInfo.vue?vue&type=style&index=0&id=05fd2f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd2f06",
  null
  
)

export default component.exports